import { Anchor, Button, Container, Group, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

/**
 * Landing — root (/), belépés előtti oldal.
 * Most egyszerű teaser; később bővíthető tartalommal.
 */
export function LandingPage() {
  return (
    <Container size="md" pt="xl">
      <Stack gap="lg">
        <Title order={1}>Szülői Munkaközösség (SZMK)</Title>
        <Text size="lg" c="dimmed">
          Egyszerű, átlátható osztálypénztár-kezelés szülőknek és pénztárosoknak.
        </Text>
        <Group>
          <Button component={Link} to="/login" size="md">
            Belépés
          </Button>
          <Anchor component={Link} to="/about">
            Tudj meg többet
          </Anchor>
        </Group>
      </Stack>
    </Container>
  );
}
